import './App.css';
import './css/geMain.css';
import './css/geMainMobile.css';
import './css/reset.css';
import React, {useEffect} from 'react';
import GEVideo from './js/geVideo.jsx';
import GEVideoMobile from './js/geVideoMobile.jsx';
import background from './image/qe_title.jpg';
import {BrowserView, MobileView} from 'react-device-detect';
import myBackground from './image/qe_title.jpg';

function App() {
  useEffect(() => {
    document.title = '公務員人員教材';
  }, []);

  return (
    <div className='appBox'>
      <BrowserView>
        <div className='title'></div>
        <GEVideo />
      </BrowserView>
      <MobileView>
        <div className='Mtitle'></div>
        <GEVideoMobile />
      </MobileView>
    </div>
  );
}

export default App;
